import { RootState } from 'editor/src/store/index';

const getSpreadsCount = (state: RootState) => state.design.designData?.spreads.length || 0;

export default getSpreadsCount;
